export const STEPS_CONFIG = {
    form: [
        { label: 'registerForm_accountData' },
        { label: 'registerForm_personalData' }
    ],
    bank: [
        { label: 'registerForm_checkData' },
        { label: 'registerForm_enterData' },
        { label: 'registerForm_registration' }
    ]
};

export const HEADERS = {
    form: [
        { translation_key: 'registerForm_registerStepOne' },
        { translation_key: 'registerForm_registerStepTwo' }
    ],
    bank: [
        { translation_key: 'registerForm_headerCheckData' },
        { translation_key: 'registerForm_headerEnterData' },
        { translation_key: 'registerForm_headerRegister' }
    ]
}